import { Component, Input } from '@angular/core';
import { EmergencyAlert } from '@core/models/emergency-alert-response.model';
import { IconNames } from '@shared/enums/icon-names';
import { MatIcon } from '@angular/material/icon';
import { NgStyle, DatePipe } from '@angular/common';

@Component({
  selector: 'app-emergency-alert',
  templateUrl: './emergency-alert.component.html',
  styleUrls: ['./emergency-alert.component.scss'],
  imports: [NgStyle, MatIcon, DatePipe],
})
export class EmergencyAlertComponent {
  @Input() alertMessages: EmergencyAlert[] = [];

  IconNames = IconNames;
  isOpen = false;
}
